// import { ConnectedRouter } from 'connected-react-router';
// import { ReduxRouter } from '@lagunovsky/redux-react-router';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import type { IRouteDescriptor } from './routes';
import routes from './routes';

const AppRouter: React.FC = () => {
	const routesByData = <T extends string>(routesData: IRouteDescriptor<T>[]) => {
		return routesData.map((props) => {
			const p = props as T extends string ? IRouteDescriptor<string> : IRouteDescriptor<never>;

			return (
				<Route key={p.path + 'RouteKey'} index={p.index} path={p.path} element={<p.Component />}>
					{p.children ? routesByData(p.children) : undefined}
				</Route>
			);
		});
	};

	return (
		// <BrowserRouter>
		<Routes>{routesByData(routes)}</Routes>
		// </BrowserRouter>
	);
};

export default AppRouter;
